import React from "react";
import styled, { css } from "styled-components";
import { withTranslation } from "react-i18next";
import { Metric } from "components/metrics";
const MetricListWrap = styled.ul(
  ({ theme }) => css`
    padding: 0;

    li {
      margin-bottom: 5px;

      .prefix {
        color: ${theme.colors.gray[70]};
      }

      .name {
        font-size: ${theme.fonts.size.body};
        font-family: ${theme.fonts.family.monospace};
        word-break: break-all;

        .open:hover {
          text-decoration: none;
        }
      }

      .metric {
        margin-left: 10px;
        padding: 10px;

        h3 {
          margin-bottom: 5px;
        }
      }
    }

    dl {
      margin-top: 0;
      margin-bottom: 0;
    }
  `
);
class MetricsList extends React.Component {
  constructor() {
    super(...arguments);
    this._formatMetric = (metric) => {
      const { namespace, nodeId } = this.props;
      return /* @__PURE__ */ React.createElement("li", { key: `li-${metric.full_name}` }, /* @__PURE__ */ React.createElement(Metric, { key: metric.full_name, metric, namespace, nodeId }));
    };
  }
  render() {
    const { names, t } = this.props;
    const metrics = names.sort((m1, m2) => m1.full_name.localeCompare(m2.full_name)).map((metric) => this._formatMetric(metric));
    return /* @__PURE__ */ React.createElement(MetricListWrap, null, metrics.length > 0 ? metrics : /* @__PURE__ */ React.createElement("li", null, t("metrics_list.no_metrics")));
  }
}
export default withTranslation("system")(MetricsList);
